<template>
  <div>
    <el-dialog title="配件审核" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
               :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog"  width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
               @close="dialogClose" v-el-drag-dialog v-el-dialog-center>

      <!-- 品牌信息 -->
      <div class="detail-wrap">
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <el-row>
              <el-form :model="formData">
                <el-col :span="7">
                  <el-form-item label="发出类型">
                    <el-select :value="formData.outType" :disabled="true">
                      <el-option :value="1" label="总部"/>
                      <el-option :value="2" label="中心"/>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item label="配送方式">
                    <el-select v-model="formData.deliverType" placeholder="">
                      <el-option v-for="item in shippingMethodList" :key="item.value" :label="item.label"
                                 :value="item.value"/>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-form>
            </el-row>
            <el-row>
              <el-col :span="24">
                <vxe-table
                  style="margin-top: 0px;"
                  :stripe="true"
                  :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                  :row-config="{height: 30,isHover: true,padding: 0,}"
                  :row-style="{ fontSize: '12px',  }"
                  show-overflow
                  height="300"
                  :column-config="{ resizable: true }"
                  @checkbox-change="selectChangeEvent"
                  @checkbox-all="selectChangeEvent"
                  :data="formData.spPartsApplyLineDTOList">
                  <vxe-column type="checkbox" width="40"/>
                  <vxe-column field="partsCode" title="配件编码"></vxe-column>
                  <vxe-column field="partsName" title="配件名称"></vxe-column>
                  <vxe-column field="partsName" title="发出仓库">
                    <template #default>
                      <span>{{formData.outWarehouseName}}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="invQty" title="库存数量"></vxe-column>
                  <vxe-column field="applyQty" title="申请数量"></vxe-column>
                  <vxe-column field="checkQty" title="审核数量">
                    <template #default="{row}">
                      <vxe-input size="small" v-model="row.checkQty" type="number" min="1" max="1000" :clearable="false"></vxe-input>
                    </template>
                  </vxe-column>

                </vxe-table>
              </el-col>
            </el-row>
          </div>


        </div>
      </div>
      <span slot="footer" class="dialog-footer">

			  <el-button type="primary" plain class="button-sty" @click="dialogClose">
				  <i class="el-icon-close el-icon"></i>
				  取 消
			  </el-button>
			  <el-button type="primary" @click="doAudit" class="button-sty">
				  <i class="el-icon-check el-icon"></i>
				  确 定
			  </el-button>
		  </span>
    </el-dialog>

  </div>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import pager from '@/components/pager/index.vue';
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import orderDialog from '@/views/dialogCommon/radioOrderDialog.vue';
import store from "@/store";
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'formData', 'shippingMethodList'],
  mixins: [selectDialogMixins],
  components: {preconditionDialog, pager, orderDialog},

  created() {
    this.initSetting()
    let temp = []
    this.formData.spPartsApplyLineDTOList.forEach(item => {
      item.checkQty = item.applyQty
      temp.push(item)
    })
    this.formData.spPartsApplyLineDTOList = temp
  },

  watch: {

  },

  mounted() {
    this.loadInvData()
  },

  computed: {

  },

  data() {
    return {

      showEdit: false,

      formData: {

      },
      showOrderDialog: false,
      showDialog: true,
      falseValue: false,
      selectMulti: true,


    };
  },


  methods: {
    loadInvData() {
      this.$http({
        url: api.spPartsApplyHeader.getInvDataUrl,
        method: 'post',
        data: {id: this.formData.id}
      }).then(res => {
        let data = res.data.data
        this.formData.spPartsApplyLineDTOList.forEach(item => {
          data.forEach(item1 => {
            if (item1.id == item.id) {
              item.invQty = item1.invQty
            }
          })
        })
      })
    },

    doAudit() {
      let deliverType = this.formData.deliverType;
      if (deliverType) {
        this.shippingMethodList.forEach(item => {
          if (deliverType == item.value) {
            this.formData.deliverTypeName = item.label
          }
        })
      }
      this.$http({
        url: api.spPartsApplyHeader.auditDataUrl,
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$message.success('操作成功')
        this.$emit('goBackIndex')
      })
    },

    //
    // // 当前页面确认按钮逻辑
    // commitData() {
    //   if (this.formData.itemId === '') {
    //     this.$message.warning('请选择关联产品')
    //   }
    //   if (this.formData.profileId !== '') {  // 有profileId,为修改用户状态，调用接口操作，接口返回成功传数据给父元素
    //     this.$http({
    //       url: this.formData.id === '' ? this.addDataUrl : this.updateDataUrl,
    //       method: 'post',
    //       data: this.formData
    //     }).then(res => {
    //       this.$message.success(this.formData.id === '' ? '添加成功' : '修改成功')
    //
    //       this.$emit('commitData', this.formData, true)
    //       this.dialogClose()
    //     })
    //   } else {
    //     if (this.formData.id === '') {
    //       this.formData.id = new Date().getTime()
    //     }
    //     // if (this.formData.contractFile !== undefined && this.formData.contractFile.length !== 0) {
    //     //   this.formData.eleRepariUrl = this.formData.contractFile[0].url
    //     // } else {
    //     //   this.formData.eleRepariUrl = ''
    //     // }
    //     this.$emit('commitData', this.formData, false)
    //     this.dialogClose()
    //   }
    // },



  }
};
</script>
<style lang="scss" scoped>
.papers {
  position: absolute;
  left: 292px;
  top: 0px;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

// ::v-deep .el-dialog {
//     margin-top: 110px !important;
//     overflow: hidden;
// }


.d-item {
  border: 1px solid #ededed;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;
}

.table-detail tr {
  margin-bottom: 10px;
  display: inline-block;

  th {
    font-weight: 400;
    text-align: right;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);

  }

  // td{
  // 	display: inline-block;
  // 	width: 170px !important;
  // }
}

::v-deep tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.detail-wrap {
  background-color: #fff;
  padding: 5px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  // margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}
.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

</style>
